import { Box, Typography, TextField, Button } from "@mui/material";
import React from "react";

export const Step7 = (props) => {
  const {
    register,
    errors,
    calculateTotalFileSize,
    setUploadedDamageFiles,
    uploadedDamageFiles,
  } = props;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">Documentación Adicional</Typography>
      <Typography variant="p">
        Si tiene alguna otra información relevante, por favor, menciónelo en
        este apartado.
      </Typography>

      <TextField
        {...register("informacionAdicional")}
        label="Escriba aquí cualquier información adicional que considere relevante."
        fullWidth
        multiline
        minRows={4}
        sx={{ mb: 2, mt: 2 }}
        error={!!errors.numeroEstancias}
        helperText={errors.numeroEstancias?.message}
      />
      <Typography variant="subtitle1">
        Sube documentos, fotos o videos
      </Typography>
      <Typography
        variant="body2"
        color={
          calculateTotalFileSize() > 24 * 1024 * 1024 ? "error" : "inherit"
        }
      >
        Tamaño total:{" "}
        {Math.round((calculateTotalFileSize() / 1024 / 1024) * 100) / 100} MB /
        25 MB
      </Typography>
      <Button variant="outlined" component="label" fullWidth sx={{ mb: 2 }}>
        Seleccionar archivos
        <input
          type="file"
          hidden
          multiple
          accept="image/*, video/*, application/pdf"
          onChange={(e) => {
            const newFiles = Array.from(e.target.files);
            setUploadedDamageFiles((prevFiles) => [...prevFiles, ...newFiles]);
          }}
        />
      </Button>

      {uploadedDamageFiles.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2">Archivos seleccionados:</Typography>
          <ul>
            {uploadedDamageFiles.map((file, index) => (
              <li key={index}>
                {file.name}
                <Button
                  variant="text"
                  color="error"
                  sx={{ ml: 2 }}
                  onClick={() => {
                    setUploadedDamageFiles((prevFiles) =>
                      prevFiles.filter((_, i) => i !== index)
                    );
                  }}
                >
                  ✖︎ Eliminar
                </Button>
              </li>
            ))}
          </ul>
        </Box>
      )}
    </Box>
  );
};

export default Step7;
